import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import ColorSF2 from '../../styles/common/ColorSF2';

const Contents = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  @media (max-height: 530px) {
    font-size: 12px;
  }
`;
const ContentWrapper = styled.div`
  width: 100%;
  display: flex;
  background-color: ${ColorSF2.white};
  border: 1px solid ${ColorSF2.mediumGray};

  &:nth-child(2) {
    border-top: none;
  }
`;
const InputWrapper = styled.div`
  display: flex;
  align-items: center;
`;
const InputTitle = styled.div`
  width: 120px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${ColorSF2.lightGray};
  color: ${ColorSF2.black};
  font-size: 12px;
  font-weight: 600;
`;
const Input = styled.input`
  width: 200px;
  height: 20px;
  margin-left: 8px;
  margin-right: 5px;
  @media (max-height: 530px) {
    font-size: 12px;
  }
`;

const SearchBox = ({ searchOptions, onUpdate }) => {
  const { operatorName, title, subtitle } = searchOptions;
  return (
    <Contents>
      <ContentWrapper>
        <InputWrapper>
          <InputTitle>
            <FormattedMessage id="blackboardList.item.title" />
          </InputTitle>
          <Input
            id="searchTitle"
            defaultValue={title}
            onChange={e => onUpdate({ title: e.target.value })}
          />
        </InputWrapper>
        <InputWrapper>
          <InputTitle>
            <FormattedMessage id="blackboardList.item.subtitle" />
          </InputTitle>
          <Input
            id="searchSubtitle"
            defaultValue={subtitle}
            onChange={e => onUpdate({ subtitle: e.target.value })}
          />
        </InputWrapper>
      </ContentWrapper>
      <ContentWrapper>
        <InputWrapper>
          <InputTitle>
            <FormattedMessage id="blackboardList.item.operatorName" />
          </InputTitle>
          <Input
            id="searchOoperatorName"
            defaultValue={operatorName}
            onChange={e => onUpdate({ operatorName: e.target.value })}
          />
        </InputWrapper>
      </ContentWrapper>
    </Contents>
  );
};

SearchBox.propTypes = {
  searchOptions: PropTypes.object.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

export default SearchBox;
